<template>
    <v-app>
        <AlertModal />
        <v-sheet
            :color="isOutsideDashboard ? 'bgSecondary' : 'background'"
            class="d-flex flex-column justify-center"
        >
            <router-view />
            <LanguageSelector />
        </v-sheet>
    </v-app>
</template>
<script>
import LanguageSelector from "@/components/LanguageSelector.vue";
import AlertModal from "@/components/display/AlertModal.vue";

export default {
    name: "App",
    components: {AlertModal, LanguageSelector },
    computed: {
        isOutsideDashboard() {
            // Access the current route via this.$route
            // Returns true if the path doesn't start with '/dashboard'
            return !this.$route.path.startsWith("/dashboard");
        },
    },
};
</script>

<style lang="scss"></style>
